import type { CartItem } from '@src/domains/cart/types/cart';
import { getServiceFeeDescriptions } from '@src/domains/service-fees';

export const getCartServiceFeeDescriptions = (cartItems: CartItem[]): string[] => getServiceFeeDescriptions(cartItems);
